import React, { createContext, useContext, ReactNode, useState, ReactElement } from 'react'
interface DialogContextType {
  openDialog: '' | 'endTrial' | 'event'
  setOpenDialog: (dialog: '' | 'endTrial' | 'event') => void
  setEndTrialContent: (content: ReactElement | string | null) => void
  endTrialContent: ReactElement | string | null
}

const DialogContext = createContext<DialogContextType | undefined>(undefined)

interface DialogProviderProps {
  children: ReactNode
}
export const DialogProvider: React.FC<DialogProviderProps> = ({ children }) => {
  const [endTrialContent, setEndTrialContent] = useState<ReactElement | string | null>(null)
  const [openDialog, setOpenDialog] = useState<'' | 'endTrial' | 'event'>('')

  return (
    <DialogContext.Provider
      value={{
        openDialog,
        endTrialContent,
        setOpenDialog,
        setEndTrialContent,
      }}
    >
      {children}
    </DialogContext.Provider>
  )
}

export const useDialog = () => {
  const context = useContext(DialogContext)
  if (!context) {
    throw new Error('useDialog must be used within a DialogProvider')
  }

  return context as DialogContextType
}
